<template>
    <form class="ministry-form form-horizontal" @submit.prevent="submit()">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="Configuración Certificado" name="general" >
                <div class="form-group" :class="{'has-error': errors['nombre_certificado']}">
                    <label for="id" class="col-sm-2 control-label">Nombre certificado</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="nombre_certificado" v-model="data.nombre_certificado">
                        <div class="help-block" v-for="e in errors['nombre_certificado']">{{e}}</div>
                    </div>
                </div>
                <div class="form-group" :class="{'has-error': errors['pdf']}">
                    <label for="name" class="col-sm-2 control-label">PDF</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="pdf" v-model="data.pdf">
                        <div class="help-block" v-for="e in errors['pdf']">{{e}}</div>
                    </div>
                </div>
                <div class="form-group" :class="{'has-error': errors['nombre_archivo']}">
                    <label for="shortname" class="col-sm-2 control-label">Nombre archivo</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="nombre_archivo" v-model="data.nombre_archivo">
                        <div class="help-block" v-for="e in errors['nombre_archivo']">{{e}}</div>
                    </div>
                </div>
                <div class="form-group" :class="{'has-error': errors['descripcion']}">
                    <label for="description" class="col-sm-2 control-label">Descripción</label>
                    <div class="col-sm-10">
                        <textarea class="form-control" id="descripcion" v-model="data.descripcion" rows="5"></textarea>
                        <div class="help-block" v-for="e in errors['descripcion']">{{e}}</div>
                    </div>
                </div>
                <div class="form-group" :class="{'has-error': errors['endpoint']}">
                    <label for="endpoint" class="col-sm-2 control-label">Endpoint</label>
                    <div class="col-sm-10">
                        <input class="form-control" id="endpoint" v-model="data.endpoint" rows="5"></input>
                        <div class="help-block" v-for="e in errors['endpoint']">{{e}}</div>
                    </div>
                </div>
                <div class="form-group" :class="{'has-error': errors['id_tarea']}">
                    <label for="shortname" class="col-sm-2 control-label">ID de Tarea</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="idTarea" v-model="data.id_tarea">
                        <div class="help-block" v-for="e in errors['id_tarea']">{{e}}</div>
                    </div>
                </div>
                <div class="form-group" :class="{'has-error': errors['id_proceso']}">
                    <label for="shortname" class="col-sm-2 control-label">ID de Proceso</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="idProceso" v-model="data.id_proceso">
                        <div class="help-block" v-for="e in errors['id_proceso']">{{e}}</div>
                    </div>
                </div>
                <div class="form-group"  :class="{'has-error': errors['claveunica']}" >
                    <label for="alias" class="col-sm-2 control-label">¿Requiere autenticación mediante ClaveÚnica?</label>
                    <div class="col-sm-10">
                        <el-switch v-model="data.claveunica"></el-switch>
                    </div>
                </div>
                <div class="form-group"  :class="{'has-error': errors['active']}" >
                    <label for="alias" class="col-sm-2 control-label">¿Activo?</label>
                    <div class="col-sm-10">
                        <el-switch v-model="data.active"></el-switch>
                    </div>
                </div>
            </el-tab-pane>

            <el-tab-pane label="Ajustes Transaccionales" name="configuracion" >
                <div class="form-group" :class="{ 'has-error': errors['linkedPage'] }">
                    <label for="linkedPage" class="col-sm-2 control-label">Ficha Asociada</label>
                    <div class="col-sm-10">
                        <pages-select id="linkedPage" :multipleLimit="1" v-model="data.linked_page"></pages-select>
                        <div class="help-block" v-for="e in errors['linkedPage']">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group"  :class="{'has-error': errors['visible_micha']}" >
                    <label for="alias" class="col-sm-2 control-label">¿Visible en Mi ChileAtiende?</label>
                    <div class="col-sm-10">
                        <el-switch v-model="data.visible_micha"></el-switch>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/certificados">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
.el-select {
    display: block;
}
</style>
<script>
    import ElSwitch from 'element-ui/lib/switch';
    import ElTabs from 'element-ui/lib/tabs';
    import ElTabPane from 'element-ui/lib/tab-pane';
    import PagesSelect from './PagesSelect.vue';
    import { Message } from "element-ui";

    export default {
        components:{
            ElSwitch,
            ElTabs,
            ElTabPane,
            PagesSelect
        },
        name: "CertificateForm",
        data (){
            const data = {
                id: null,
                nombre_certificado: null,
                descripcion: null,
                nombre_archivo: null,
                pdf: null,
                id_tarea: null,
                id_proceso: null,
                created_at: null,
                updated_at: null,
                claveunica: false,
                active: true,
                visible_micha: true,
                linked_page: null,
                order: null,
                endpoint: null
            };
            _.assign(data, this.certificate);
            if (this.pageid != 0){
                const set = new Set([this.pageid]);
                data.linked_page = Array.from(set);
            }
            data.author = this.author;
            return{
                data: data,
                activeName: 'general',
                errors: {}
            }
        },
        props: ['certificate','edit','pageid','author'],
        methods:{
            submit: function(){
                var self = this;
                var errores = {};

                self.data.endpoint = self.data.endpoint.trim();

                if(!self.data.endpoint || self.data.endpoint.length == 0){
                    errores["endpoint"] = ["El campo Endpoint no puede estar vacío."];
                }else{
                    if(self.data.endpoint.substring(0,1) == '/'){
                        errores["endpoint"] = ["El campo Endpoint no debe comenzar con '/' dado que son url internas."];
                    }else{
                        if(self.data.endpoint.substring(0,4) != 'http' || self.data.endpoint.length < 4 ){
                            errores["endpoint"] = ["El campo Endpoint debe comenzar con 'http' o 'https'."];
                        }
                        if(self.data.endpoint.charAt(self.data.endpoint.length-1) == '/'){
                            errores["endpoint"] = ["El campo Endpoint no debe terminar con '/'."];
                        }
                    }
                }

                if (_.size(errores) > 0) {
                    self.errors = errores;
                    self.$message.error(
                        "Revise los errores en el formulario para continuar."
                    );
                    return false;
                }

                axios({
                    url: self.edit ? 'backend/certificados/'+self.data.id : 'backend/certificados',
                    method: self.edit ? 'PUT' : 'POST',
                    data: self.data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                });
            },
            handleClick(tab, event) {
                //console.log(tab, event);
            }
        }
    }
</script>